/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import SelectStepItem from "../components/booking/SelectStepItem";
import SelectedServicesCard from "../components/booking/SelectedServicesCard";
import SelectedProviderCard from "../components/booking/SelectedProviderCard";
import SelectedDateTimeCard from "../components/booking/SelectedDateTimeCard";
import FooterStepButton from "../components/FooterStepButton";
import { ROUTES } from "../constants/constants";
import Icon from "../components/ui/Icon";
import BookingStepList from "../components/booking/steps/BookingStepList";
import { useBooking } from "../hooks/useBooking";
import { useDispatch } from "react-redux";
import { setFlow, FlowType } from "../store/slices/flowSlice";

const Home = ({ back }) => {
  const dispatch = useDispatch();
  const { selectedServices, selectedProvider, selectedDate, selectedTime } = useBooking();

  useEffect(() => {
    dispatch(setFlow(FlowType.BOOKING));
  }, []);

  return (
    <Container>
      <NavigationHeader location locationSelectable navigation cart clientLogin back={back} />
      <BookingStepList>
        <SelectStepItem
          navigateTo={ROUTES.SERVICES}
          icon={<Icon.SelectServices size={Icon.SIZE.SM} />}
          label="Select services"
          selectedStep={
            selectedServices.length ? (
              <SelectedServicesCard services={selectedServices} canSelect={true} canDelete={true} />
            ) : undefined
          }
        />
        {!selectedProvider?.hide_other_providers && (
          <SelectStepItem
            navigateTo={ROUTES.PROVIDERS}
            icon={<Icon.SelectProvider size={Icon.SIZE.SM} />}
            label="Select provider"
            selectedStep={
              selectedProvider ? (
                <SelectedProviderCard provider={selectedProvider} canSelect={true} canDelete={true} />
              ) : undefined
            }
          />
        )}
        <SelectStepItem
          navigateTo={ROUTES.DATETIME}
          icon={<Icon.SelectDateTime size={Icon.SIZE.SM} />}
          label="Pick date and time"
          selectedStep={
            selectedDate && selectedTime ? <SelectedDateTimeCard canSelect={true} canDelete={true} /> : undefined
          }
          disabled={!(selectedServices.length && selectedProvider)}
        />

      </BookingStepList>
      {!!selectedServices.length && selectedProvider && selectedDate && selectedTime && <FooterStepButton />}
    </Container>
  );
};

export default Home;
